import { createContext, useContext, useEffect, useState } from "react";
import api from "../../api";
import Cookies from "universal-cookie";
const cookies = new Cookies();

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [loading, setLoading] = useState(
    cookies.get("access_token") ? true : false
  );
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(cookies.get("access_token"));
  const [reference, setReference] = useState([]);

  const removeAuth = async () => {
    cookies.remove("access_token");
    cookies.remove("refresh_token");

    setIsAuthenticated(false);
    setToken("");
    setUser(null);
  };

  const setAuth = (access_token) => {
    cookies.set("access_token", access_token);
    setToken(access_token);
  };

  const fetchMe = async () => {
    const res = await api.me();
    // console.log("/me res --->", res);
    if (res.status === 200) {
      // console.log("User data:", res.data);
      setIsAuthenticated(true);
      setUser(res.data.data);
    } else {
      // console.error("Error fetching user data:", res);
      setUser(null);
      setIsAuthenticated(false);
    }
    setLoading(false);
  };

  const fetchComplainType = async () => {
    const res = await api.get_complaint_reference();
    // console.log("/me res --->", res);
    if (res.status === 200) {
      setReference(res.data.data);
    } else {
      // console.log(res.data.message || "Алдаа гарлаа");
    }
  };

  useEffect(() => {
    if (!user && token) {
      fetchMe();
      fetchComplainType();
    }
  }, [user, token]);

  if (loading) return null;

  return (
    <AuthContext.Provider
      value={{
        removeAuth,
        isAuthenticated,
        user,
        setUser,
        setAuth,
        reference,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
